<div
  *ngIf="showBanner"
  class="fixed bottom-6 right-6 z-[10000] w-96 max-w-[calc(100vw-48px)] p-6 bg-slate-900 text-slate-100 border border-slate-800 rounded-2xl shadow-2xl transition-all duration-300 ease-out"
  [class.opacity-0]="isClosing"
  [class.translate-y-4]="isClosing"
  role="dialog"
  aria-labelledby="cookie-title"
  aria-describedby="cookie-desc"
>
  <div class="flex flex-col gap-4">
    <!-- Header with Icon -->
    <div class="flex items-center gap-3">
      <div class="p-2 bg-indigo-500/10 text-indigo-400 rounded-xl">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="w-5 h-5"
        >
          <path
            d="M12 2c-.34 0-.67.04-1 .12a9.12 9.12 0 0 0-.25 18c.39.06.79.08 1.25.08 5.52 0 10-4.48 10-10a1 1 0 0 0-1-1c-.55 0-1-.45-1-1a3 3 0 0 1-3-3 1 1 0 0 0-1-1 3 3 0 0 1-3-3 1 1 0 0 0-1-1Zm-3 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm6.5 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM12 11.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
          />
        </svg>
      </div>
      <h3
        id="cookie-title"
        class="text-base font-semibold text-white tracking-tight"
      >
        Cookie Consent
      </h3>
    </div>

    <!-- Body -->
    <div>
      <p id="cookie-desc" class="text-xs leading-relaxed text-slate-400">
        We use cookies and telemetry (Grafana Faro) to analyze traffic, enhance
        performance, and personalize your experience. We do not track you
        without your consent. Read our
        <a
          routerLink="/privacy"
          class="text-indigo-400 font-medium hover:text-indigo-300 underline"
          >Privacy Policy</a
        >
        to learn more.
      </p>
    </div>

    <!-- Buttons -->
    <div class="flex items-center justify-end gap-3 mt-1">
      <button
        type="button"
        class="daisy-btn daisy-btn-sm daisy-btn-outline daisy-btn-neutral border-slate-700 text-slate-300 hover:text-white"
        (click)="onDecline()"
        aria-label="Decline non-essential tracking"
      >
        Decline
      </button>
      <button
        type="button"
        class="daisy-btn daisy-btn-sm daisy-btn-primary bg-gradient-to-r from-indigo-600 to-indigo-500 border-none text-white shadow-lg shadow-indigo-600/20"
        (click)="onAccept()"
        aria-label="Accept all cookies"
      >
        Accept All
      </button>
    </div>
  </div>
</div>
